import { FaUpload, FaTrash } from "react-icons/fa";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Box,
  VStack,
  HStack,
  Text,
  Button,
  Input,
} from "@chakra-ui/react";

export function PhotoEvidenceField({
  value,
  preview,
  onSelect,
  onClear,
  fieldName,
  inputRef,
  onBlur,
  error,
}) {
  return (
    <FormControl isInvalid={!!error}>
      <FormLabel mb={3}>Attach photo evidence</FormLabel>

      <VStack spacing={3} w="full">
        <Box
          borderWidth={2}
          borderStyle="dashed"
          borderColor="gray.200"
          _hover={{ borderColor: "rgba(73, 67, 149, 0.4)" }}
          borderRadius="xl"
          p={4}
          bg="gray.50"
          textAlign="center"
          cursor="pointer"
          transition="all 0.2s"
          position="relative"
          minH="110px"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Input
            type="file"
            accept="image/*"
            capture="environment"
            position="absolute"
            inset={0}
            opacity={0}
            cursor="pointer"
            w="full"
            h="full"
            zIndex={10}
            onBlur={onBlur}
            name={fieldName}
            ref={inputRef}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) onSelect(file);
            }}
          />

          <Box
            mb={1}
            color="gray.400"
            _hover={{ color: "#494395" }}
            transition="colors 0.2s"
            fontSize="24px"
          >
            <FaUpload />
          </Box>

          <VStack spacing={0.5}>
            <Text fontSize="xs" fontWeight="bold" color="gray.700">
              {value ? (
                <Text as="span" color="#2AB4AA">
                  Selected: {value.name}
                </Text>
              ) : (
                "Choose File"
              )}
            </Text>
            <Text fontSize="10px" color="gray.400" mt={0.5}>
              {value
                ? "Click again or drag to swap image file"
                : "Required for evidence of visit"}
            </Text>
          </VStack>
        </Box>

        {preview && value && (
          <HStack
            spacing={3}
            p={2}
            borderWidth={1}
            borderColor="gray.100"
            bg="white"
            borderRadius="xl"
            boxShadow="sm"
            w="fit-content"
            animation="fadeIn 0.2s"
          >
            <Box
              position="relative"
              w={14}
              h={14}
              borderRadius="lg"
              overflow="hidden"
              borderWidth={1}
              borderColor="gray.200"
              flexShrink={0}
            >
              <img
                src={preview}
                alt="Photo evidence preview"
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              />
            </Box>

            <Box pr={2}>
              <Text
                fontSize="xs"
                fontWeight="medium"
                color="gray.700"
                maxW="180px"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {value.name}
              </Text>
              <Button
                as="button"
                type="button"
                variant="unstyled"
                fontSize="10px"
                fontWeight="semibold"
                color="red.500"
                _hover={{ textDecoration: "underline" }}
                mt={0.5}
                onClick={onClear}
                leftIcon={<FaTrash size={10} />}
              >
                Remove file
              </Button>
            </Box>
          </HStack>
        )}
      </VStack>

      {error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
}
